import React, { useEffect } from 'react'

const About = () => {
  useEffect(() => {
    window.scrollTo(900, 900);
  },[]);
  return (
    <div>
       <div>
  {/* About Start */}
  <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
    <div className="container py-5">
      <div className="row g-5">
        <div className="col-lg-7">
          <div className="section-title position-relative pb-3 mb-5">
            <h5 className="fw-bold text-primary text-uppercase">About Us</h5>
            <h1 className="mb-0">The Best IT Training With 15+ Years of Experience</h1>
          </div>
          <p className="mb-4">Acrosys Technologies has been providing a wide range of information technology (IT) consulting services including Remote DBA services, Software Development, IT Staffing services (Developers, DBAs, Sys Admins, Network Admins, Solution
            Architects, Project Managers,Tech Leads and Data Entry Specialists), IT Training services, IT Help Desk Solutions, and Records Management Training and consulting services at a reasonable cost.</p>
          <div className="row g-0 mb-3">
            <div className="col-sm-6 wow zoomIn" data-wow-delay="0.2s">
              <h5 className="mb-3"><i className="fa fa-check text-primary me-3" />Award Winning</h5>
              <h5 className="mb-3"><i className="fa fa-check text-primary me-3" />Professional Staff</h5>
            </div>
            <div className="col-sm-6 wow zoomIn" data-wow-delay="0.4s">
              <h5 className="mb-3"><i className="fa fa-check text-primary me-3" />24/7 Support</h5>
              <h5 className="mb-3"><i className="fa fa-check text-primary me-3" />Fair Prices</h5>
            </div>
          </div>
          <div className="d-flex align-items-center mb-4 wow fadeIn" data-wow-delay="0.6s">
            <div className="bg-primary d-flex align-items-center justify-content-center rounded" style={{width: 60, height: 60}}>
              <i className="fa fa-phone-alt text-white" />
            </div>
            <div className="ps-4">
              <h5 className="mb-2">Call to ask any question</h5>
              <h4 className="text-primary mb-0">+91 86672 02180</h4>
            </div>
          </div>
          <a href="quote.html" className="btn btn-primary py-3 px-5 mt-3 wow zoomIn" data-wow-delay="0.9s">Request</a>
        </div>
        <div className="col-lg-5" style={{minHeight: 500}}>
          <div className="position-relative h-100">
            <img className="position-absolute w-100 h-100 rounded wow zoomIn" data-wow-delay="0.9s" src="assets/img/about.jpg" style={{objectFit: 'cover'}} />
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* About End */}
  {/* Features Start */}
  <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
    <div className="container py-5">
      <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{maxWidth: 600}}>
        <h5 className="fw-bold text-primary text-uppercase">Why Choose Us</h5>
        <h1 className="mb-0">We aim at bridging this gap by offering specialized Software Training to freshers &amp; experienced candidates.</h1>
      </div>
      <div className="row g-5">
        <div className="col-lg-4">
          <div className="row g-5">
            <div className="col-12 wow zoomIn" data-wow-delay="0.2s">
              <div className="bg-primary rounded d-flex align-items-center justify-content-center mb-3" style={{width: 60, height: 60}}>
                <i className="fa fa-cubes text-white" />
              </div>
              <h4>Best In Industry</h4>
              <p className="mb-0">We simulate live projects and assign it to candidates enrolled with us as a part of their curriculum</p>
            </div>
            <div className="col-12 wow zoomIn" data-wow-delay="0.6s">
              <div className="bg-primary rounded d-flex align-items-center justify-content-center mb-3" style={{width: 60, height: 60}}>
                <i className="fa fa-award text-white" />
              </div>
              <h4>Award Winning</h4>
              <p className="mb-0">This helps them follow live scenarios and understand what happens in real life Sofware situations.</p>
            </div>
          </div>
        </div>
        <div className="col-lg-4  wow zoomIn" data-wow-delay="0.9s" style={{minHeight: 350}}>
          <div className="position-relative h-100">
            <img className="position-absolute w-100 h-100 rounded wow zoomIn" data-wow-delay="0.1s" src="assets/img/feature.jpg" style={{objectFit: 'cover'}} />
          </div>
        </div>
        <div className="col-lg-4">
          <div className="row g-5">
            <div className="col-12 wow zoomIn" data-wow-delay="0.4s">
              <div className="bg-primary rounded d-flex align-items-center justify-content-center mb-3" style={{width: 60, height: 60}}>
                <i className="fa fa-users-cog text-white" />
              </div>
              <h4>Professional Staff</h4>
              <p className="mb-0">Well Trained staffs for both Indidual &amp; Corportate Clients</p>
            </div>
            <div className="col-12 wow zoomIn" data-wow-delay="0.8s">
              <div className="bg-primary rounded d-flex align-items-center justify-content-center mb-3" style={{width: 60, height: 60}}>
                <i className="fa fa-phone-alt text-white" />
              </div>
              <h4>Life time Support</h4>
              <p className="mb-0">Provide Extensive Support through lifetime to buildup their future requirements</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* Features Start */}
</div>

    </div>
  )
}

export default About